<template>
  <div>
    <template v-if="isDrawerOpen(activeShift) || isPreviousShift">
      <div class="row">
        <div class="col-md-6">
          <drawer-status-label class="mb-2" :shift="selectedShift" />
          <button
            type="button"
            class="btn btn-link btn-sm text-info"
            @click="handleStartShift()"
            v-if="!isDrawerOpen(selectedShift) && canUpdateDrawer"
          >
            <i class="fas fa-lock-open" /> Abrir caixa
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="handleEndShift()"
            v-if="isDrawerOpen(selectedShift) && canUpdateDrawer"
          >
            <i class="fas fa-lock" /> Fechar caixa
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            v-if="isPreviousShift"
            @click="handleBackToActiveShift()"
          >
            <i class="fas fa-arrow-left" /> Voltar para caixa atual.
          </button>
          <button type="button" class="btn btn-warning btn-sm ml-2" v-if="canReopenDrawer" @click="handleReopenShift()">
            <i class="fas fa-lock-open" /> Reabrir caixa
          </button>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm ml-2"
            @click="handleSelectShift()"
          >
            <i class="fas fa-search" /> Consultar turnos anteriores.
          </button>
        </div>
        <div class="col-md-6 text-right">
          <b-dropdown
            right
            size="sm"
            class="mr-2"
            variant="success"
            v-if="canAddNew"
          >
            <template v-slot:button-content>
              <i class="fas fa-plus" /> Novo
            </template>
            <b-dropdown-item @click="handleNewAccountTransaction()">
              <i class="fas fa-plus" />
              Novo Lançamento
            </b-dropdown-item>

            <b-dropdown-item @click="handleNewTransafer()">
              <i class="fas fa-exchange-alt" />
              Transferência
            </b-dropdown-item>
          </b-dropdown>
          <button
            class="btn btn-sm btn-primary ml-2"
            @click="handleOpenAccountResumeModal()"
          >
            <i class="fas fa-equals" />
            Resumo
          </button>
          <button @click="openDrawerReport()" type="button" class="btn btn-sm btn-primary ml-3">
            <i class="fas fa-print mr-1" />Relatório
          </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-8">
          <drawer-account-transaction-list
            :account-resume="accountResume"
            :account-transactions="accountTransactions"
            @openBillPaymentModal="openBillPaymentModal($event)"
            @pagechange="handlePageChange($event)"
            @cancel="handleOpenAccountTransactionCancelForm($event)"
          />
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <account-resume-list :account-resume="accountResume" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row mt-5">
        <div class="col-md-12 text-center">
          Caixa Fechado
          <br />
          <button
            type="button"
            class="btn btn-success"
            @click="handleStartShift()"
          >
            <i class="fas fa-plus" /> Abrir Caixa
          </button>
          <br />
          <button
            type="button"
            class="btn btn-outline-primary btn-sm mt-2"
            @click="handleSelectShift()"
          >
            <i class="fas fa-search" /> Consultar turnos anteriores.
          </button>
        </div>
      </div>
    </template>

    <error-handler :error="error" />

    <account-transaction-form ref="accountTransactionForm" @stored="boot()" />
    <account-transfer-form ref="accountTransferForm" @stored="boot()" />
    <start-shift-form ref="startShiftForm" />
    <end-shift-form ref="endShiftForm" @update="boot()" />
    <reopen-shift-form ref="reopenShiftForm" @update="boot()" />
    <shift-select-modal ref="shiftSelectModal" @input="loadShift($event)" />
    <account-transaction-cancel-form
      ref="accountTransactionCancelForm"
      @cancelled="loadTransactions()"
    />
    <account-transaction-bill-paymentModal
      ref="accountTransactionBillPaymentModal"
    />
    <account-resume-modal ref="accountResumeModal" />
  </div>
</template>

<script>
import AccountResumeModal from "@/components/account/sections/AccountResumeModal";
import AccountTransactionForm from "@/components/account/forms/AccountTransactionForm";
import AccountTransferForm from "@/components/account/forms/AccountTransferForm";
import DrawerStatusLabel from "@/components/account/sections/DrawerStatusLabel.vue";
import StartShiftForm from "@/components/account/forms/StartShiftForm.vue";
import EndShiftForm from "@/components/account/forms/EndShiftForm.vue";
import DrawerAccountTransactionList from "@/components/account/sections/DrawerAccountTransactionList.vue";
import AccountResumeList from "@/components/account/sections/AccountResumeList.vue";
import AccountTransactionCancelForm from "@/components/account/forms/AccountTransactionCancelForm";
import AccountTransactionBillPaymentModal from "@/components/sections/AccountTransactionBillPaymentModal";
import ShiftSelectModal from "@/components/account/sections/ShiftSelectModal.vue";
import ReopenShiftForm from "@/components/account/forms/ReopenShiftForm.vue";
import Drawer from "@/mixins/account/Drawer";

export default {
  components: {
    AccountResumeModal,
    AccountTransactionForm,
    AccountTransferForm,
    DrawerStatusLabel,
    StartShiftForm,
    EndShiftForm,
    ShiftSelectModal,
    DrawerAccountTransactionList,
    AccountResumeList,
    AccountTransactionCancelForm,
    AccountTransactionBillPaymentModal,
    ReopenShiftForm
  },

  mixins: [Drawer],

  data: () => ({
    isPreviousShift: false,

    selectedShift: null,

    previousShift: null,

    accountTransactions: {
      data: [],
    },

    params: {
      account_id: null,
      shift_id: null,
      page: 1,
    },

    accountResume: null,

    error: null,
  }),

  computed: {
    account() {
      return this.$store.getters["account/selectedAccount"];
    },

    activeShift() {
      return this.account.active_shift;
    },

    canAddNew() {
      return !this.isPreviousShift && this.isDrawerOpen(this.selectedShift);
    },

    canUpdateDrawer() {
      return !this.isPreviousShift;
    },

    canReopenDrawer() {
      return !this.isDrawerOpen(this.selectedShift) && !this.activeShift;
    },
  },

  watch: {
    account() {
      this.boot();
    },
  },

  mounted() {
    this.boot();
  },

  methods: {
    async boot() {
      this.reset();

      if (this.account.active_shift) {
        this.params.account_id = this.account.id;
        this.params.shift_id = this.account.active_shift.id;
        this.params.page = 1;

        await this.loadTransactions();
      }
    },

    async loadTransactions() {
      this.$store.commit("showLoading");
      console.log(this.params);
      let transactionsResponse = await this.$store.dispatch(
        "drawer/getDrawerTransactions",
        this.params
      );

      this.accountTransactions = transactionsResponse.data.accountTransactions;

      let resumeResponse = await this.$store.dispatch(
        "drawer/getDrawerResume",
        this.params
      );

      this.accountResume = resumeResponse.data;
      this.$store.commit("hideLoading");
    },

    handlePageChange(page) {
      this.params.page = page;
      this.loadTransactions();
    },

    reset() {
      this.isPreviousShift = false;
      this.accountTransactions = [];
      this.accountResume = null;
      this.selectedShift = this.account.active_shift;
    },

    async loadShift(shift) {
      this.params.account_id = this.account.id;
      this.params.shift_id = shift.id;
      this.params.page = 1;

      await this.loadTransactions();
      this.$store.commit("drawer/selectedShift", shift);

      this.selectedShift = shift;

      if (!this.activeShift) {
        this.isPreviousShift = true;
      } else {
        this.isPreviousShift = this.activeShift.id !== shift.id;
      }
    },

    handleBackToActiveShift() {
      this.boot();
    },

    handleStartShift() {
      this.$refs.startShiftForm.open(this.account);
    },

    handleEndShift() {
      this.$refs.endShiftForm.open(this.account, this.params.shift_id);
    },

    handleNewAccountTransaction() {
      this.$refs.accountTransactionForm.open(this.account.id);
    },

    handleNewTransafer() {
      this.$refs.accountTransferForm.open(this.account.id);
    },

    handleSelectShift() {
      this.$refs.shiftSelectModal.open(this.account.id);
    },

    handleReopenShift() {
      this.$refs.reopenShiftForm.open(this.account, this.params.shift_id);
    },

    handleOpenAccountTransactionCancelForm(accountTransaction) {
      this.$refs.accountTransactionCancelForm.open(accountTransaction);
    },

    handleOpenAccountResumeModal() {
      this.$refs.accountResumeModal.open(this.account.id)
    },

    openBillPaymentModal(accountTransaction) {
      if (this.$acl.can("accountTransactionCreateEdit")) {
        this.$refs.accountTransactionBillPaymentModal.open(
          accountTransaction.id
        );
      }
      // this.$refs.accountResumeModal.open(this.account.id);
    },
    openDrawerReport() {
      window.open("/caixas/" + this.account.description + "/relatorio/" + this.account.id + '/' + this.params.shift_id);
    },
  },
};
</script>

<style>
</style>